import { render, staticRenderFns } from "./VisitStatus.vue?vue&type=template&id=ed5421d2&"
import script from "./VisitStatus.vue?vue&type=script&lang=js&"
export * from "./VisitStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports